import React, { useState } from "react";
import PropTypes from "prop-types";
import sanitizeHtml from "sanitize-html";
import TruckingIndustryHero from "@components/TruckingIndustryPage/TruckingIndustryHero";
import TruckingIndustryPageStyles from "@components/TruckingIndustryPage/TruckingIndustryPageStyles";
import WhyAccount from "@components/TruckingIndustryPage/WhyAccount";
import Row from "@components/EntityFormation/LandingPage/brownSectionRow";
import QandAComponent from "@components/QandA/QandAComponent";
import FaqComponent from "@components/Bookkeeping/FaqComponent";
import WhyAccountStyles from "@components/TruckingIndustryPage/WhyAccountStyles";
import PullUpScheduler from "@components/PullUpScheduler/PullUpSchedulerV2";
import useMediaQuery from "@/helpers/hooks/useMediaQuery.js";

const TruckingIndustryPage = ({
  data,
  isSchedulerOpen,
  toggleIsSchedulerOpen,
}) => {
  const {
    hero_sub_title,
    hero_title,
    background_models,
    how_we_help,
    how_we_help_title,
    cta_text,

    why_image,
    why_subtitle,
    why_title,
    why_inner_title,

    bn_title,
    business_needs,

    about_services,
    common_content,

    consultation_title,
    consultation_services,
    consultation_cta_text,
    consultation_image,
    statistics,
    testimonials,

    business_features,
    business_features_image,
    business_features_title,

    faq_title,
    q_and_a,

    wwo_section_title,
    section_subtitle,
    offered_product,

    additional_questions,
    lead_values,
    paid_campaign,

    bottom_title,
    bottom_subtitle,
    bottom_cta,
  } = data;
  
  const hero = {
    title: hero_title,
    subtitle: hero_sub_title,
    image: background_models[0].image,
    ctaText: cta_text,
  };

  const whyAccount = {
    why: {
      image: why_image,
      subtitle: why_subtitle,
      title: why_title,
      innerTitle: why_inner_title,
    },

    businessNeeds: {
      title: bn_title,
      list: business_needs,
    },

    scheduledConsultation: {
      title: consultation_title,
      list: consultation_services,
      image: consultation_image,
      cta: consultation_cta_text,
    },
  };

  const tax_preparation = common_content.tax_preparation;
  const faq = common_content.faq;
  const get_started = common_content.get_started;

  const onScheduleAppointment = () => toggleIsSchedulerOpen();
  const isMobile = useMediaQuery("(max-width: 576px)");

  return (
    <TruckingIndustryPageStyles>
      <TruckingIndustryHero data={hero} onCtaClicked={onScheduleAppointment} />
      <WhyAccount
        data={whyAccount}
        onCtaClicked={onScheduleAppointment}
        isMobile={isMobile}
      />
      <div className="why-accountant-section">
        <div className="container">
          {about_services.map((service, idx) => (
            <Row
              key={idx}
              service={service}
              idx={idx}
              isMobile={isMobile}
              isTaxAdvisoryPage={true}
              onCtaClicked={onScheduleAppointment}
            />
          ))}
        </div>
      </div>

      {/* What You Get Section */}

      <section className="tax-preparation">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              {isMobile ? (
                <>
                  <h2>
                    {tax_preparation.title.slice(0, 15)}
                    {"\n"}
                    {tax_preparation.title.slice(16)}
                  </h2>
                  <p className="taxDescription">
                    {tax_preparation.description}
                  </p>
                </>
              ) : (
                <>
                  <h2>{tax_preparation.title}</h2>
                  <p className="taxDescription">
                    {tax_preparation.description}
                  </p>
                </>
              )}
              <div className="row">
                <div className="cards-container">
                  {tax_preparation.tax_fields.map((tax, index) => (
                    <div className="card" key={index}>
                      <img
                        src={tax.image}
                        alt="Tax Advisory"
                        width="500px"
                        height="500px"
                      />
                      <div className="title">
                        <h3>{tax.tax_title}</h3>
                      </div>
                      <div className="card-body pb-0 px-0">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: sanitizeHtml(tax.tax_description, {
                              allowedTags: ["p", "ul", "li", "a"],
                              allowedAttributes: {
                                p: [""],
                                a: ["href"],
                              },
                            }),
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="faq-section">
        <FaqComponent title={faq.faq_title} faqs={faq.q_and_a} />
      </div>

      {/* Start now section */}
      <WhyAccountStyles style={{ background: "#F9F6F4", paddingTop: 25 }}>
        <div className="container custom-container scheduled-consultation">
          {!isMobile && (
            <div className="image-wrapper">
              <img
                src={get_started.image}
                alt="Get started image"
                width="500px"
                height="500px"
              />
            </div>
          )}

          <div className="consultation-text-container">
            <h2 className="consultation-title">{get_started.title}</h2>
              {isMobile ? 
                <p>{get_started.body_copy.slice(0, 34) + "\n" + get_started.body_copy.slice(34, 62) + "\n" + get_started.body_copy.slice(62, 96) + "\n" + get_started.body_copy.slice(96)}</p>
                : 
                <p>{get_started.body_copy.slice(0, 43) + "\n" + get_started.body_copy.slice(43, 80) + "\n" + get_started.body_copy.slice(80, 113) + "\n" +get_started.body_copy.slice(113)}</p>
              }
            <button
              onClick={onScheduleAppointment}
              className="btn btn-secondary bottom-cta"
            >
              {get_started.button_text}
            </button>
          </div>
          {isMobile && (
            <div className="image-wrapper">
              <img
                src={get_started.image}
                alt="Get Started Illustrative Image"
                width="500px"
                height="500px"
              />
            </div>
          )}
        </div>
      </WhyAccountStyles>

      {isSchedulerOpen && (
        <PullUpScheduler
          setIsSchedulerOpen={toggleIsSchedulerOpen}
          AdditionalQuestions={additional_questions}
          leadValues={lead_values}
          PaidCampaign={paid_campaign}
        />
      )}
    </TruckingIndustryPageStyles>
  );
};

TruckingIndustryPage.propTypes = {
  data: PropTypes.object.isRequired,
};

export default TruckingIndustryPage;
